import { createStore, type MarlinStore } from "@observe-tech/marlin-store/core";
import { createHostCapabilities } from "@observe-tech/marlin-store/capabilities";
import type { PreloadAppMethods } from "@observe-tech/utils";

type Options = { name?: string; onClosed?: () => void };

type TestHooksBridge = Partial<Pick<PreloadAppMethods, "testHooksEnabled">>;

declare global {
  interface Window {
    __OBSERVE_SHELL_HOST__?: { store: MarlinStore };
  }
}

export const createStoreForHost = (
  options: Options = {},
): Promise<MarlinStore> => createStore(createHostCapabilities(), options);

export const publishTestHost = async (store: MarlinStore): Promise<void> => {
  const bridge = (window as unknown as { electronAPI?: TestHooksBridge })
    .electronAPI;
  if ((await bridge?.testHooksEnabled?.()) !== true) return;
  window.__OBSERVE_SHELL_HOST__ = { store };
};
